<script lang="ts">
    interface Props {
        title: string;
        imageUrl: string;
    }

    let { title, imageUrl }: Props = $props();
</script>

<div class="page-heading-section" style="background-image: url({imageUrl});">
    <div class="container">
        <h1 class="page-heading-section__heading">{title}</h1>
    </div>
</div>

<style>
    .page-heading-section {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 300px;
        background-position: center;
        background-size: cover;
        position: relative;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.7);
        }
    }

    .container {
        position: relative;
        z-index: 1;
    }

    .page-heading-section__heading {
        color: #fff;
        font-weight: 300;
        text-align: center;
    }
</style>